import { render, staticRenderFns } from "./SubmitNew.vue?vue&type=template&id=a683c544"
import script from "./SubmitNew.vue?vue&type=script&lang=js"
export * from "./SubmitNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports